<template>
  <v-container>
    <component :is="getFormazioneComponent" />
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  import Index from './../components/magazzino/lessons/Index'
  import Insert from './../components/magazzino/lessons/Insert'

  export default {
    name: 'MagazzinoAccessori',
    components: {
      Index,
      Insert
    },
    computed: {
      ...mapGetters([
        'getFormazioneComponent'
      ])
    },
    methods: {
      ...mapMutations([
        'CHANGE_FORMAZIONE_COMPONENT'
      ])
    },
    destroyed() {
      this.CHANGE_FORMAZIONE_COMPONENT('Index')
    }
  }
</script>

<style>
</style>